import * as React from "react";
import {
    Box,
    Card,
    CardHeader,
    Grid,
    Typography
} from "@mui/material";

import TotalOrderContainers from "../../assets/images/TotalOrderContainers.svg";
import MfgInProcessContainers from "../../assets/images/MfgInProcessContainers.svg";
import DispatchReadyContainers from "../../assets/images/DispatchReadyContainers.svg";
import InTransitContainers from "../../assets/images/InTransitContainers.svg";
import ContainersArrivingThisWeek from "../../assets/images/ContainersArrivingThisWeek.svg";
import ContainersOnTime from "../../assets/images/ContainersOnTime.svg";
import DelayedContainers from "../../assets/images/DelayedContainers.svg";


const Overview = () => {

    const items = [
        { icon: TotalOrderContainers, title: "Total Order Containers", value: 15 },
        { icon: MfgInProcessContainers, title: "Mfg. in Process Containers", value: 8 },
        { icon: DispatchReadyContainers, title: "Dispatch-Ready Containers", value: 6 },
        { icon: InTransitContainers, title: "In-Transit Containers", value: 10 },
        { icon: ContainersArrivingThisWeek, title: "Containers Arriving This Week", value: 4 },
        { icon: ContainersOnTime, title: "Containers on Time", value: 12 },
        { icon: DelayedContainers, title: "Delayed Containers", value: 22 },

    ];

    return (
        <Card sx={{ p: 3 }}>

            <CardHeader
                title="OVERVIEW"
                titleTypographyProps={{
                    fontWeight: 700,
                    align: "center",
                    fontSize: "16px"
                }}
            />

            <Grid container spacing={4} justifyContent="center">
                {items.map((item, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>

                        <Box
                            sx={{
                                textAlign: "center",
                                borderRight:
                                    (index + 1) % 4 !== 0 ? "3px solid #0000000D" : "none",
                            }}
                        >
                            <Box sx={{ color: "#1976d2", mb: 0 }}>
                                <img
                                    src={item.icon}
                                    alt="Import Shipment"
                                    style={{ width: 80, height: 80, marginRight: "60px" }}
                                />

                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 1
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "28px",
                                        fontWeight: "300",
                                        color: "#000000"
                                    }}
                                >
                                    {item.value.toString().padStart(2, "0")}
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#1976d2",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        textAlign: "left",
                                        width: "120px",
                                        lineHeight: "18px",
                                        wordBreak: "break-word"
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </Box>
                        </Box>

                    </Grid>
                ))}
            </Grid>

        </Card>
    );
};

export default Overview;